import React, { useCallback, useEffect } from 'react';

import PropTypes from 'prop-types';

export default function UpdateNozzle({ close, sending, onForm }) {
  const handleSending = useCallback(async () => {
    await onForm();
    await close();
  }, []);

  useEffect(() => {
    if (sending) {
      handleSending();
    }
  }, [sending]);

  return <p>Você tem certeza que deseja continuar?</p>;
}

UpdateNozzle.propTypes = {
  close: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
};
